(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[765],{

/***/ 3396:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issues",
      function () {
        return __webpack_require__(6153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ issues; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/issues/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n display: flex;\n padding: 2vh 2vw;\n border-top: 1px solid #ddd;\n\n @media (max-width: 426px) {\n  flex-direction: column;\n  align-items: center;\n  padding: 2vh 4vw;\n }\n\n a {\n  img {\n   max-height: 15vw;\n\n   @media (max-width: 426px) {\n    max-height: 100%;\n    max-width: 100%;\n    margin: 1vh 0 2vh;\n   }\n  }\n }\n\n div {\n  max-width: 78%;\n  margin-left: 2vw;\n\n  span {\n   color: #0007;\n  }\n\n  p {\n   margin-top: 2vh;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-69242292-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/issues/index.tsx





var description = 'Lista de edi\xe7\xf5es passadas da Revista Aufkl\xe4rung.';
var title = 'Edi\xe7\xf5es';
var Archives = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: "Arquivos"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/19",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-19.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/19",
                                    children: "Dossi\xea Sartre"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 7 n. Especial (2020)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/18",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-18.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/18",
                                    children: "Revista Aufkl\xe4rung. v. 6, n. 3 (2019), Setembro-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 6 n. 3 (2019)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/17",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-17.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/17",
                                    children: "Revista Aufkl\xe4rung. Leibniz: no cora\xe7\xe3o da metaf\xedsica. v. 4, n. esp. (2019), Novembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 6 n. esp. (2019)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-16.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/16",
                                    children: "Revista Aufkl\xe4rung. v. 6, n. 2 (2019), Maio-Agosto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 6 n. 2 (2019)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/15",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-15.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/15",
                                    children: "Revista Aufkl\xe4rung. v. 6, n. 1 (2019), Janeiro-Abril"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 6 n. 1 (2019)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/14",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-14.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/14",
                                    children: "Revista Aufkl\xe4rung. v.5, n. 3 (2019), Setembro-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 5 n. 3 (2018)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/13",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-13.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/13",
                                    children: "Revista Aufkl\xe4rung. v.5, n. 2 (2019), Maio-Agosto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 5 n. 2 (2018)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-12.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/12",
                                    children: "Revista Aufkl\xe4rung. v. 5, n. 1 (2018), Janeiro-Abril"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 5 n. 1 (2018)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-11.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/11",
                                    children: "Revista Aufkl\xe4rung. v. 4, n. 3 (2017), Setembro-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 4 n. 3 (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-10.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/10",
                                    children: "Revista Aufkl\xe4rung. Linguagem e Poesia – Uma interlocu\xe7\xe3o com Heidegger, Vol.4, n. esp. (2017), Setembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 4 n. esp. (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-9.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/9",
                                    children: "Revista Aufkl\xe4rung. v. 4, n. 2 (2017), Maio-Agosto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 4 n. 2 (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-8.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/8",
                                    children: "Revista Aufkl\xe4rung. Dossi\xea Teoria Cr\xedtica, Pol\xedtica e Direito, v. 4, n. esp. (2017), Maio"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 4 n. esp. (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-7.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/7",
                                    children: "Revista Aufkl\xe4rung. v. 4, n. 1 (2017), Janeiro-Abril"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 4 n. 1 (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-6.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/6",
                                    children: "Revista Aufkl\xe4rung. v. 3, n. 2 (2016), Julho-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 3 n. 2 (2016)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-5.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/5",
                                    children: "Revista Aufkl\xe4rung. v. 3, n. 1 (2016), Janeiro-Junho"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 3 n. 1 (2016)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-4.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/4",
                                    children: "Revista Aufkl\xe4rung. v. 2, n. 2 (2015), Julho-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 2 n. 2 (2015)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-3.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/3",
                                    children: "Revista Aufkl\xe4rung. v. 2, n. 1 (2015), Janeiro-Junho"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 2 n. 1 (2015)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-2.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/2",
                                    children: "Revista Aufkl\xe4rung. v. 1, n. 2 (2014), Julho-Dezembro"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 1 n. 2 (2014)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-1.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/issues/1",
                                    children: "Revista Aufkl\xe4rung. v. 1, n. 1 (2014), Janeiro-Junho"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "v. 1 n. 1 (2014)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "As opini\xf5es e conceitos veiculados por este peri\xf3dico s\xe3o de responsabilidade dos seus autores, que gozam de plena liberdade de opini\xe3o e de cr\xedtica."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var issues = (Archives);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(3396); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);